// Accordion
// Toggles visibility of some mobile content
// ----------------------------------------------------------------

import $ from 'jquery';

const accordionTrigger = $('.amnestyfi-accordion-trigger');
const accordionContent = $(`#${accordionTrigger.attr('aria-controls')}`);

const toggleAccordion = () => {
    if (!accordionContent.hasClass('is-open')) {
        accordionContent.addClass('is-open');
        accordionTrigger.addClass('is-open');
        accordionContent.attr('aria-expanded', true);
    } else {
        accordionContent.removeClass('is-open');
        accordionTrigger.removeClass('is-open');
        accordionContent.attr('aria-expanded', false);
    }
}

$(accordionTrigger).on('click', toggleAccordion);
